export default __webpack_public_path__ + "static/dxbot-share-551fef3a9de17e36bfe10cf8cb15aa23.jpg";